import ExpertProfilePortfolioModule from './expert-profile-portfolio.module'

export default ExpertProfilePortfolioModule
